<template>
  <nav>
    <v-snackbar v-model="snackbarVisible" top color="success" :timeout="4000">
      <div class="text-center">{{ snackbarMessage }}</div>
    </v-snackbar>

		<v-toolbar dense flat class="amber">
			<v-app-bar-nav-icon @click="drawerVisible = !drawerVisible"></v-app-bar-nav-icon>
			
			<v-toolbar-title class="text-uppercase">
				<span class="font-weight-light">Lesson</span>
				<span>Squared</span>
			</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn class="mr-2 d-none d-sm-flex" text small href="https://lessonsquared.freshdesk.com/" target="_blank" >
        FAQ
      </v-btn>

      <v-btn v-if="!user.loggedIn" class="mr-2 d-none d-sm-flex" text small router :to="{ name: 'Login', params: { userType: 'student' } }">
        Students
      </v-btn>
      <v-btn v-if="!user.loggedIn" class="d-none d-sm-flex" text small router :to="{ name: 'Login', params: { userType: 'lecturer' } }">
        Lecturers
      </v-btn>
      <v-btn v-if="user.loggedIn" class="d-none d-sm-flex" depressed small router :to="{ name: 'Logout' }">
        Logout
      </v-btn>

    </v-toolbar>

    <v-navigation-drawer v-model="drawerVisible" absolute temporary color="grey lighten-4">

      <v-list nav v-if="!user.loggedIn">
        <v-list-item v-for="link in publicLinks" v-bind:key="link.text" router :to="link.routerData">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="d-flex d-sm-none" router :to="{ name: 'Login', params: { userType: 'lecturer' } }">
          <v-list-item-icon>
            <v-icon>login</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Lecturer login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="d-flex d-sm-none" router :to="{ name: 'Login', params: { userType: 'student' } }">
          <v-list-item-icon>
            <v-icon>login</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Student login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list nav v-if="user.loggedIn && user.data.userType=='LECTURER'">
        <v-list-item v-for="link in lecturerLinks" v-bind:key="link.text" router :to="link.routerData">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list nav v-if="user.loggedIn && user.data.userType=='STUDENT'">
        <v-list-item v-for="link in studentLinks" v-bind:key="link.text" router :to="link.routerData">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list-item class="d-flex d-sm-none" href="https://lessonsquared.freshdesk.com/" target="_blank">
        <v-list-item-icon>
          <v-icon>help_center</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>FAQ</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list nav v-if="user.loggedIn" class="d-flex d-sm-none">
        <v-list-item router :to="{ name: 'Logout' }">
          <v-list-item-icon>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list nav v-if="user.loggedIn && user.isAdmin">
        <v-subheader>Admin</v-subheader>
        <v-list-item v-for="link in adminLinks" v-bind:key="link.text" router :to="link.routerData">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "Navbar",
  data: function(){
    return {
      drawerVisible: false,
      snackbarVisible: false,
			publicLinks: [
				{ routerData: {name: 'Home'}, icon: 'home', text: 'Home'},
				{ routerData: {name: 'Contact'}, icon: 'email', text: 'Contact'},
				{ routerData: {name: 'Pricing'}, icon: 'attach_money', text: 'Pricing'}
			],
			lecturerLinks: [
				{ routerData: {name: 'LecturerDashboard'}, icon: 'dashboard', text: 'Dashboard'},
				{ routerData: {name: 'Schedule'}, icon: 'schedule', text: 'Schedule'},
				{ routerData: {name: 'Content'}, icon: 'topic', text: 'Content'}
			],
			studentLinks: [
				{ routerData: {name: 'StudentDashboard'}, icon: 'dashboard', text: 'Dashboard'}
			],
			adminLinks: [
				{ routerData: {name: 'Users'}, icon: 'home', text: 'Users'},
				{ routerData: {name: 'Messages'}, icon: 'message', text: 'Messages'}
			]
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
      snackbarMessage: "snackbarMessage"
    }),
    dialogVisible: {
      get() {
        return this.$store.getters.dialogVisible
      },
      set(value) {
        this.$store.dispatch('setDialogVisibility', value)
      }
    }
  },
  watch: {
    snackbarMessage: function() {
      // make the snackbar visible when its value changes
      this.snackbarVisible = true
    }
  }
}
</script>
